import { Component, EventEmitter, Injector, Input } from '@angular/core';
import { ItemFinderComponent } from '../item-finder.component';
import { Art57Section } from '../../../ui/Art57Section/Art57Section';
import { SectionName } from '../../../ui/SectionName';
import { MedicinalProductsQueryResultNode } from '../../../ui/Node/MedicinalProductsNode/MedicinalProductsQueryResultNode';
import { MeddraQueryResultNode } from '../../../ui/Node/MeddraNode/MeddraQueryResultNode';
import { WebTraderQueryResultNode } from '../../../ui/Node/WebTraderNode/WebTraderQueryResultNode';
import { SubstanceNamesQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/SubstanceNames/SubstanceNamesQueryNode';
import { OwnedEVMPDEntitiesQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/OwnedEVMPDEntities/OwnedEVMPDEntitiesQueryNode';
import { OwnedByEVMPDEntitiesQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/OwnedEVMPDEntities/OwnedByEVMPDEntitiesQueryNode';
import { QueryNodeMessageBox } from '../../../ui/Node/WebTraderNode/QueryNodeMessageBox';

@Component({
  selector: 'app-item-finder-array-model',
  templateUrl: './item-finder-array-model.component.html',
  styleUrl: './item-finder-array-model.component.scss'
})
export class ItemFinderArrayModelComponent extends ItemFinderComponent {
  override selectedNode: any;
  @Input() override doAction = new EventEmitter<any>();
  @Input() override itemFinderDoubleClick = new EventEmitter<any>();
  constructor(override injector: Injector) {
    super(injector);
  }
  selectedItem: any = null;


  override onItemFinderDoubleClick(node: any) {
    switch (this.injector.get(Art57Section).selectionSectionName) {
      case SectionName.webtrader:
        this.itemFinderDoubleClick.emit(node);
        break;
    }
  }
  
  override ngOnDestroy(){
    if ((!(this.selectedNode instanceof MedicinalProductsQueryResultNode) &&
         !(this.selectedNode instanceof WebTraderQueryResultNode) &&
         !(this.selectedNode instanceof MeddraQueryResultNode)) && 
        (this.selectedNode.data.model && this.selectedNode.data.model.length > 0)
      ) {
      this.selectedNode.data.model = [];
      this.selectedNode.showResults = false;
    }

  }

 excludeCheckBox() {
  return (this.selectedNode.parent &&
   this.selectedNode.parent.parent && (
   this.selectedNode.parent.parent instanceof SubstanceNamesQueryNode ||
   this.selectedNode.parent.parent instanceof OwnedEVMPDEntitiesQueryNode ||
   this.selectedNode.parent.parent instanceof OwnedByEVMPDEntitiesQueryNode) );
 }

 isWebTraderQueryResultNode():boolean{
  return (this.selectedNode instanceof WebTraderQueryResultNode) ||
         (this.selectedNode instanceof QueryNodeMessageBox);
 }

 
selectRow(item: any) {
  this.selectedItem = item;
}

    

}
